import React from "react";

import { Box } from "@mui/material";

import { mediaUrl } from "../../../helper-functions/api/imageQueries";

/** Display a cached cocktail photo (from Sheets HTML/ZIP export). */
export default function CocktailImage(props) {
    const { drink, height = 160, borderRadius = 0 } = props;

    return (
        <Box sx={{ position: "relative", width: "100%", height, bgcolor: "action.hover" }}>
            <Box
                component="img"
                src={mediaUrl(drink?.imageUrl)}
                alt={drink?.name || "Cocktail"}
                onError={(e) => {
                    e.currentTarget.src = "/images/image_placeholder.png";
                }}
                sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius,
                    display: "block"
                }}
            />
        </Box>
    );
}
